const pageNames = Object.freeze({
  // <---- Channel Steering Page Group ---->
  contactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::contact-us:::',
  },
  callUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::callus:::',
  },
  emailPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::email:::',
  },
  emailByPassPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::emailByPass:::',
  },
  intermediatePage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::intermediate:::',
  },
  chatBot: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chatBot:::',
  },

  // <---- Error Pages ---->
  ErrorPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::error:::',
  },
  emailByPassPageError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::emailByPass-error:::',
  },
  chatBotArticleInEligible: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::smart-chatBotInEligible:::',
  },

  // <---- HCR Page Group ---->
  homePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::home:::',
  },
  PCCTrackingPage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::pcc:::',
  },
  searchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search:::',
  },
  articlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article:::',
  },
  articleErrorPage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article-error:::',
  },
  topicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
  },
  chatBotHome: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::chatBot:::',
  },
  chatBotArticle: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::chatBot:::',
  },
  topicErrorPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic-error:::',
  },
  articleintermediatePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::intermediate:::',
  },
});

const PageMapping = {
  'contact-us': 'contactUsPage',
  callus: 'callUsPage',
  email: 'emailPage',
  home: 'homePage',
  search: 'searchPage',
  article: 'articlePage',
  topic: 'topicPage',
};

module.exports = {
  pageNames,
  PageMapping,
};
